<fgb-mobile-page-header [pageTitle]="'contact.us.page.title'" backButtonLink="/" [showBalance]="false" [showQr]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'contact.us.page.title' | translate" />

<div class="mobile-container pb-5">
  <fgbcl-contact-us></fgbcl-contact-us>
</div>
